<template>
  <!-- Main sidebar -->
  <div class="sidebar sidebar-main" :class="loggedInUserData.is_staff ? 'sidebar-admin' : 'cus-sidebar'">
    <div class="sidebar-content">
      <!-- Main navigation for STAFF -->
      <div
        class="sidebar-category sidebar-category-visible"
        v-if="loggedInUserData.is_staff || showAdminSections"
      >
        <button @click="toggleAllNavigations" class="toggle-nav-btn">
          <i class="fa fa-caret-down mr-1" :class="{ 'rotated': allNavigationsExpanded }"></i>
          Toggle All Navigations
        </button>
        <div class="category-content no-padding">
          <ul class="navigation navigation-main navigation-accordion">
            <!-- Main -->
            <!-- <li class="navigation-header">
              <span>Main</span> <i class="icon-menu" title="Main pages"></i>
            </li> -->
            <!-- <li v-if="loggedInUserData.is_staff">
              <a><i style="font-size: 18px" class="material-icons">dashboard</i> <span>Dashboard</span></a>
            </li> -->
            <div
              class="sidebar-user-material"
              v-if="$_has_perm('view_pallet_report')"
            >
              <div class="category-content pt-0" style="background-color:#16182EFF;">
                <div class="sidebar-user-material-menu mt-0">
                  <router-link
                    to="/"
                    style="font-size: 15px; font-weight: bold;"
                  ><span><i
                        class="fa fa-th-large"
                        style="font-size: 14px; margin-right: 8px"
                      ></i>Dashboard</span></router-link>
                </div>
              </div>
            </div>
            <div class="sidebar-user-material orders">
              <div class="category-content pt-0" style="background-color:#16182EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav10"
                    data-toggle="collapse"
                    aria-expanded="true"
                  ><span>Orders</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse in"
                id="user-nav10"
                aria-expanded="true"
              >
                <ul class="navigation" style="background-color:#2C315BFF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_ship_only')"
              to="/ship-only"
              tag="li"
              active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-plus"
                    /> Ship Only
                  </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_new_order')"
                  to="/new-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                        style="font-size: 18px"
                        class="material-icons"
                      >add_box</i>
                    New Orders
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_pending_answer_order')"
                  to="/pending-answer-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-adn"
                    />
                    Pending Answer
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_processed_order')"
                  to="/processed_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-cog"
                    />Processed Orders</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_canceled_order')"
                  to="/canceled_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-times"
                    />Canceled</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_approved_order')"
                  to="/approved_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-check"
                    />Approved Orders</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_refunded_order')"
                  to="/refunded_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >block</i>Refunded</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_partial_refund')"
                  to="/secret?component=partial-refund"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      class="fa fa-file-text-o"
                      style="font-size: 16px"
                    />
                    Partial Refund
                  </a>
                </router-link>
                <router-link
                  v-if="$_has_perm('view_purchased_order')"
                  class="sidebar-mobile-main-toggle"
                  to="/purchased_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >add_shopping_cart</i>Purchased</a></router-link>
                <router-link
                  v-if="$_has_perm('view_warehouse_delivered_order')"
                  class="sidebar-mobile-main-toggle"
                  to="/warehouse_delivered_order"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-wordpress"
                    ></i> Warehouse Delivered</a></router-link>
                <router-link
                  v-if="$_has_perm('view_pending_to_shipment_order')"
                  class="sidebar-mobile-main-toggle"
                  to="/pending_to_shipment_order"
                  tag="li"
                  active-class="active"
                ><a><span class="pending-boat-icon">
    <i class="material-icons boat-base">directions_boat</i>
    <i class="material-icons boat-badge">schedule</i>
  </span>
                    Pending To
                    Shipment</a></router-link>
                <router-link
                  v-if="$_has_perm('view_shipment_order')"
                  class="sidebar-mobile-main-toggle"
                  to="/int_shipment_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >directions_boat</i>International
                    Shipment</a></router-link>
                <router-link
                  v-if="$_has_perm('view_pallet_report')"
                  class="sidebar-mobile-main-toggle"
                  to="/pallets"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-plane"
                    ></i>Pallets</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_pending_to_branch')"
                  to="/pending_to_branch_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="fa fa-product-hunt"
                    />
                    Pending To Branch
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_branch_delivered_order')"
                  to="/branch_delivery_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >local_shipping</i>
                    Delivered to Erbil
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_delivered_order')"
                  to="/user-delivered-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      local_taxi
                    </i>
                    Delivered
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_archived_order')"
                  to="/admin-archived-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      archive
                    </i>
                    Archived
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_exportable_order')"
                  to="/exportable-order"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-file-excel-o"
                    ></i> Exportable Orders</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_warehouse_passed_order')"
                  to="/warehouse-date-passed"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-calendar"
                    ></i>Warehouse Passed</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_all_order')"
                  to="/all-order"
                  tag="li"
                  active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-cubes"
                    ></i>All Orders</a></router-link>
                    <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_not_found_order')"
                  to="/not-found-orders"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-eye-slash"
                    />
                    Not Found Orders
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_purchase_history')"
                  to="/purchase-history"
                  tag="li"
                  active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-clock-o"
                    ></i>Purchase History</a></router-link>
                </ul>
              </div>
            </div>

            <!-- Export Orders -->
            <div class="sidebar-user-material export-order">
              <div class="category-content pt-0" style="background-color:#7A8088FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav5"
                    data-toggle="collapse"
                  ><span>Export</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav5"
              >
                <ul class="navigation" style="background-color:#9EA6B0FF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_order')"
              to="/export-order/pending"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plus"
                />
                New Export Orders
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_processed_export_order')"
              to="/export-order/processed"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-cog"
                />
                Processed
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_canceled_export_order')"
              to="/export-order/canceled"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-times"
                />
                Canceled
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_approved_export_order')"
              to="/export-order/approved"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check"
                />
                Approved
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_sent_export_order')"
              to="/export-order/sent"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plane"
                />
                Sent
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_received_export_order')"
              to="/export-order/received"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check-circle"
                />
                Received
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_history')"
              to="/export-order/export-history"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-history"
                />
                Export History
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_order_refund')"
              to="/export-order/refunded"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-undo"
                />
                Refunded Orders
              </a>
            </router-link>
                </ul>
              </div>
            </div>

            <hr class="my-0" />
            <div class="sidebar-user-material delivery">
              <div class="category-content pt-0" style="background-color:#731212FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav13"
                    data-toggle="collapse"
                  ><span>Delivery</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav13"
              >
                <ul class="navigation" style="background-color:#912121FF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_order_delivery')"
              to="/order-delivery"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-motorcycle"
                />
                Order Delivery
              </a>
            </router-link>
                </ul>
              </div>
            </div>
            <hr
              v-if="$_has_perm('view_not_found_order') || $_has_perm('view_order_case')"
              class="my-0"
            />
            <hr class="my-0" />

            <div class="sidebar-user-material invoices">
              <div class="category-content pt-0" style="background-color:#927805FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav11"
                    data-toggle="collapse"
                  ><span>Invoices</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav11"
              >
                <ul class="navigation" style="background-color:#AE8F09FF;">
                <router-link
                class="sidebar-mobile-main-toggle"
                v-if="$_has_perm('view_shipping_invoice')"
                to="/order_invoice"
                tag="li"
                active-class="active"
              ><a><i
                    class="fa fa-file-text-o"
                    style="font-size: 16px"
                  ></i>Shipping Invoice</a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                v-if="$_has_perm('view_order_invoice')"
                to="/secret?component=credit-log-transaction"
                tag="li"
                active-class="active"
              ><a><i
                    class="fa fa-file-text-o"
                    style="font-size: 16px"
                  ></i>Order Invoice</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_credit')"
                  to="/secret?component=credit-log-action"
                  tag="li"
                  active-class="active"
                ><a><i
                      class="fa fa-file-text-o"
                      style="font-size: 16px"
                    ></i>Credit Invoice</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_delivery_invoice')"
                  to="/secret?component=delivery-invoice"
                  tag="li"
                  active-class="active"
                ><a><i
                      class="fa fa-motorcycle"
                      style="font-size: 16px"
                    ></i>Delivery Invoice</a></router-link>
                </ul>
              </div>
            </div>


            <hr class="my-0" />
            <!-- <li v-if="$_has_perm('')">
              <a href=""><i style="font-size: 18px" class="material-icons">swap_horiz</i><span>Transactions</span></a>
              <ul>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-transaction"
                  tag="li"
                  active-class="active"
                ><a>Order Invoice</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-action"
                  tag="li"
                  active-class="active"
                ><a>Credit</a></router-link>
              </ul>
            </li> -->
              <div class="sidebar-user-material finance">
              <div class="category-content pt-0" style="background-color:#3E8195FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav4"
                    data-toggle="collapse"
                  ><span>Finance</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav4"
              >
                <ul class="navigation" style="background-color:#4C9EB8;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_expense')"
              to="/secret?component=expense"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-eur"
                  style="font-size: 16px"
                ></i>Expenses</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_bank')"
                    to="/banks"
                    tag="li"
                    active-class="active"
                  ><a><i
                        style="font-size: 18px"
                        class="material-icons"
                      >account_balance</i>Banks</a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_currency_rate')"
                    to="/currency-rate"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 18px"
                        class="material-icons"
                      >
                        loop
                      </i>
                      Currency Rates
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_profit')"
                    to="/secret?component=profit"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-pie-chart"
                        style="font-size: 16px"
                      ></i>Profit</a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_capital')"
                    to="/secret?component=capital"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-database"
                        style="font-size: 16px"
                      ></i>Capital</a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_money')"
                    to="/secret?component=put_money"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-plus"
                        style="font-size: 16px"
                      />
                      Add Money
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_money_transfer')"
                    to="/secret?component=money-transfer"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-share"
                        style="font-size: 16px"
                      ></i>Money Transfer</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_expense_type')"
                    to="/secret?component=expense-type"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-file-text"
                        style="font-size: 16px"
                      ></i>Expense Type</a></router-link>
                </ul>
              </div>
            </div>
            <!-- <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_exchange_rate')"
              to="/exchange-rate"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >loop</i>Exchange rates</a></router-link> -->
            <!-- <router-link
              v-if="$_has_perm('view_branch')"
              class="sidebar-mobile-main-toggle"
              to="/branch"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-home pl-2"
                  style="font-size: 16px"
                />
                Branches
              </a>
            </router-link> -->

            <hr
              class="my-0"
            />

            <div class="sidebar-user-material cases">
              <div class="category-content pt-0" style="background-color:#7A5A3EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav6"
                    data-toggle="collapse"
                  ><span>Cases</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav6"
              >
                <ul class="navigation" style="background-color:#956D4B;">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_order_case')"
                    to="/order-cases"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-folder-open"
                      />
                      Order Cases
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_progress_order_case') || $_has_perm('view_order_case')"
                    to="/order-case-progress"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-folder-open"
                      />
                      Order Cases Progress
                    </a>
                  </router-link>
                </ul>
              </div>
            </div>

            <div class="sidebar-user-material customers">
              <div class="category-content pt-0" style="background-color:#4D125EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav7"
                    data-toggle="collapse"
                  ><span>Customers</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav7"
              >
                <ul class="navigation" style="background-color:#601674FF;">
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_customer')"
                  to="/regular-user"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >person</i>Customer</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_customer_subscription')"
                  to="/customer-subscription"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">card_membership</i>Customer Subscription</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_loaned_customer')"
                  to="/loan-customers"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >person</i>Loaned customer</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_credit')"
                  to="/secret?component=credit"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >attach_money</i>Customer
                    Credit</a></router-link>
                  <router-link
                    v-if="$_has_perm('view_customer_price')"
                    class="sidebar-mobile-main-toggle"
                    to="/secret?component=customer-prices"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-money"
                        style="font-size: 16px"
                      ></i>Customer prices</a></router-link>
                </ul>
              </div>
            </div>

            <div class="sidebar-user-material report">
              <div class="category-content pt-0" style="background-color:#80864DFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav8"
                    data-toggle="collapse"
                  ><span>Reports</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav8"
              >
                <ul class="navigation" style="background-color:#9BA25C;">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_delivered_report')"
                    to="/delivered-report"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-line-chart pl-2"></i>Delivered report</a></router-link>
                </ul>
              </div>
            </div>

            <div class="sidebar-user-material mobile-app">
              <div class="category-content pt-0" style="background-color:#C67101FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav2"
                    data-toggle="collapse"
                  ><span>Mobile App</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav2"
              >
                <ul class="navigation" style="background-color:#FF8F00;">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_about')"
                    to="/about"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-info-circle pl-2"
                      />
                      About App
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('send_notification')"
                    to="/send-notification"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-bell pl-2"
                      />
                      Send Notification
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_home_banner')"
                    class="sidebar-mobile-main-toggle"
                    to="/home-banner"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-image pl-2"
                        style="font-size: 16px"
                      />
                      Home Banner
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_home_slider')"
                    class="sidebar-mobile-main-toggle"
                    to="/home-slider"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-image pl-2"
                        style="font-size: 16px"
                      />
                      Home Slider
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_popular_website')"
                    class="sidebar-mobile-main-toggle"
                    to="/popular-website"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      Popular Websites
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_global_website')"
                    class="sidebar-mobile-main-toggle"
                    to="/global-website-group"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      Global Websites
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_force_update')"
                    class="sidebar-mobile-main-toggle"
                    to="/force-update"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-underline pl-2"
                        style="font-size: 16px"
                      />
                      Force Update
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_our_address')"
                    class="sidebar-mobile-main-toggle"
                    to="/our-address"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-map-marker pl-2"
                        style="font-size: 16px"
                      />
                      Our Address
                    </a>
                  </router-link>
                </ul>
              </div>
            </div>

            <div class="sidebar-user-material admin">
              <div class="category-content pt-0" style="background-color:#2A4A77FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    id="user-nav"
                    href="#user-nav3"
                    data-toggle="collapse"
                  ><span>Admin</span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper collapse"
                id="user-nav3"
              >
                <ul class="navigation" style="background-color:#3261A3FF;">
                  <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_order_type')"
                  to="/order-types"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">category</i>Order Types</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_subscription')"
                  to="/subscription"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >subscriptions</i>Subscription</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_subscription_pricing')"
                  to="/subscription-pricing"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">category</i>Subscription Pricing</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_reason')"
                    to="/reason"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-ban"
                        style="font-size: 16px"
                      ></i>Cancellation Reason</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_staff')"
                    to="/users"
                    tag="li"
                    active-class="active"
                  >
                  <a><i
                        style="font-size: 18px"
                        class="material-icons"
                      >group</i>Staff</a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_role')"
                    class="sidebar-mobile-main-toggle"
                    to="/roles"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-shield pl-2"
                        style="font-size: 16px"
                      />
                      Roles
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_coupon')"
                    to="/secret?component=coupon"
                    tag="li"
                    active-class="active"
                  >
                  <a><i
                        class="fa fa-credit-card-alt"
                        style="font-size: 16px"
                      ></i>Coupons</a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_warehouse')"
                    class="sidebar-mobile-main-toggle"
                    to="/warehouse"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-home pl-2"
                        style="font-size: 16px"
                      />
                      Warehouse
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_governorate')"
                    class="sidebar-mobile-main-toggle"
                    to="/governorate"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      Governorates
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_city')"
                    class="sidebar-mobile-main-toggle"
                    to="/city"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-home pl-2"
                        style="font-size: 16px"
                      />
                      Cities
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_company_fee')"
                    class="sidebar-mobile-main-toggle"
                    to="/secret?component=kreenex-fee-prices"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-money"
                        style="font-size: 16px"
                      ></i>ShipZone Fee</a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_supplier')"
                    to="/supplier"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-users"
                        style="font-size: 16px"
                      ></i>Suppliers</a>
                  </router-link>
                  <router-link
              v-if="$_has_perm('view_order_log')"
              class="sidebar-mobile-main-toggle"
              to="/secret?component=order-log"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >swap_vert</i>
                Order Log
              </a>
            </router-link>
                </ul>
              </div>
            </div>

          </ul>
        </div>
      </div>
      <!-- /main navigation for staff -->

      <!-- Main navigation for CUSTOMER -->
      <div v-if="!loggedInUserData.is_staff">
        <div
          class="sidebar-category sidebar-category-visible"
          v-if="loggedInUserData.phone_number && loggedInUserData.address"
        >
          <div class="category-content no-padding">
            <ul class="navigation navigation-main navigation-accordion">
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-ship-only"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add</i>
                  <span>Ship Only</span></a></router-link>
                  <router-link
              class="sidebar-mobile-main-toggle"
              to="/new-ship-only"
              tag="li"
              active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-plus"
                    /> Ship Only (New)
                  </a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add_box</i>
                  <span>New Order</span>
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-export-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-share-square-o"
                  />
                  Export Order
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >filter_none</i>
                  <span>Orders</span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/archived-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >
                    archive
                  </i>
                  Archived Orders
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order-cases"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 16px"
                    class="fa fa-folder-open"
                  />
                  Order Cases
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/charge-balance"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-money"
                  />
                  Charge Balance
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/check-rate"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-calculator"
                  />
                  Check Rate
                </a>
              </router-link>
              <li>
                <a href="#invoice-menu" data-toggle="collapse" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                    <span><i
                    style="font-size: 18px; padding: 1px;"
                    class="material-icons"
                  >assignment</i><span style="padding: 10px 15px;">Invoices</span></span>
                  <i class="fa fa-angle-down mt-1" style="font-size: 16px" aria-hidden="true"></i></a>
                <ul id="invoice-menu" class="collapse">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Order Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-order-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Shipping Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-credit-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Credit Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-partial-refund"
                    tag="li"
                    active-class="active"
                  ><a>Partial Refund Invoices</a></router-link>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- /main navigation for CUSTOMER -->
    </div>
  </div>
  <!-- /main sidebar -->
</template>

<script>
export default {
  props: ['loggedInUserData'],

  data() {
    return {
      showAdminSections: false,
      allNavigationsExpanded: false
    }
  },

  methods: {
    toggleAllNavigations() {
      this.allNavigationsExpanded = !this.allNavigationsExpanded

      // Get all navigation sections with user-nav in their ID
      const navElements = document.querySelectorAll('[id^="user-nav"]')

      navElements.forEach(nav => {
        if (this.allNavigationsExpanded) {
          // Expand all navigations
          if (!nav.classList.contains('in')) {
            // Find the corresponding toggle and click it to expand
            const toggle = document.querySelector(`[href="#${nav.id}"]`)
            if (toggle) {
              toggle.classList.remove('collapsed')
              nav.classList.add('in')
              nav.style.height = 'auto'
              nav.setAttribute('aria-expanded', 'true')
            }
          }
        } else {
          // Collapse all navigations
          if (nav.classList.contains('in')) {
            // Find the corresponding toggle and click it to collapse
            const toggle = document.querySelector(`[href="#${nav.id}"]`)
            if (toggle) {
              toggle.classList.add('collapsed')
              nav.classList.remove('in')
              nav.style.height = '0px'
              nav.setAttribute('aria-expanded', 'false')
            }
          }
        }
      })
    }
  }
}
</script>
<style>
.sidebar-content {
  height: 94vh;
  overflow: scroll;
}
.group-title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0.8;
  padding: 6px 8px;
  margin-top: 8px;
  letter-spacing: 1.1px;
}

.navigation {
  padding: 0 !important;
}

.toggle-nav-btn {
  width: 100%;
  padding: 10px 15px;
  border: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  border-radius: 3px;
  cursor: pointer;
}

.toggle-nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.toggle-nav-btn:active {
  background-color: rgba(255, 255, 255, 0.15);
}
[data-toggle="collapse"].collapsed .fa-angle-down {
  transform: rotate(-90deg);
  transition: transform 0.2s ease;
}

.fa-angle-down {
  transition: transform 0.2s ease;
}

.fa-caret-down {
  transition: transform 0.2s ease;
}

.fa-caret-down.rotated {
  transform: rotate(180deg);
}

.toggle-nav-btn {
  width: 100%;
  padding: 10px 15px;
  border: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  border-radius: 3px;
  cursor: pointer;
}

.toggle-nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.toggle-nav-btn:active {
  background-color: rgba(255, 255, 255, 0.15);
}

.bg {
  height: 150px;
  width: 220px;
}

.fit-img {
  width: 62%;
  height: 90%;
}

.sidebar-content {
  height: 94vh;
  overflow: scroll;
}

.group-title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0.8;
  padding: 6px 8px;
  margin-top: 8px;
  letter-spacing: 1.1px;
}

.navigation {
  padding: 0 !important;
}

.pending-boat-icon {
  position: relative;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.pending-boat-icon .boat-base {
  font-size: 24px;
  line-height: 24px;
}
.pending-boat-icon .boat-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  font-size: 14px;
  background: #fff;
  color: #ff9800; /* pending color */
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0 0 0 1px #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue